export default __webpack_public_path__ + "static/media/RESENA FORTALE 2.9815e96d.png";